/*
 * @Author: 故乡情
 * @Date: 2021-09-06 09:16:13
 * @LastEditTime: 2022-02-13 22:06:10
 * @LastEditors: GXQ
 * @Description: U1
 * @FilePath: \u1\src\api\fetch.js
 */


//const baseUrl = 'http://127.0.0.1:9999'
//const baseUrl = 'https://www.aavef.com/dapp'
const baseUrl = '/dapp'

// Post 请求
export const fReq = async (body) => {
    let sendRequest = new Request(baseUrl + body.url, {
        method: 'post',
        headers: {
            'Content-Type': 'application/json;charset=utf-8;',
            //'token': await GetMyToken(account)
        },
        body: JSON.stringify(body.param)
    })

    return new Promise((resolve, rejiect) => {
        fetch(sendRequest)
            .then(response => response.json())
            .then(response => {
                // console.log(response);
                let datas = response.data
                if (response.code === 200) {
                    resolve(datas)
                } else if (response.code === 500) {
                    //GetMyToken(account, true)
                    resolve(response.message)
                } else {
                    rejiect(response)
                }
            })
            .catch(err => console.log('Request Failed', err));
    })
}

// Get 请求
export const gReq = async (body) => {
    let sendRequest = new Request(baseUrl + body.url + '?' + coverParmas(body.param), {
        method: 'get'
    })

    return new Promise((resolve, rejiect) => {
        fetch(sendRequest)
            .then(response => response.json())
            .then(response => {
                //console.log(response);
                let datas = response.data
                if (response.code === 200) {
                    resolve(datas)
                } else if (response.code === 500) {
                    resolve(response.message)
                } else {
                    rejiect(response)
                }
            })
            .catch(err => console.log('Request Failed', err));
    })
}


export const coverParmas =(json) =>{
    return Object.keys(json).map(function (key) {
        // body...
        return encodeURIComponent(key) + "=" + encodeURIComponent(json[key]);
    }).join("&");
} 

// 以下不用了
const GetMyToken = async (account, status = false) => {

    // account = 'a'
    const storageAccount = localStorage.getItem('token')
    const token = localStorage.getItem('token')
    const expired = localStorage.getItem('expired')
    const nowTime = (Date.parse(new Date()) / 1000)

    if (!token || !expired || nowTime > expired || status || !storageAccount || storageAccount !== account) {
        return new Promise((resolve, rejiect) => {
            fetch(baseUrl + '/main/save-token', {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8;'
                },
                body: JSON.stringify({ address: account })
            })
                .then(response => response.json())
                .then(function (response) {
                    let datas = response.message.data
                    if (response.optCode === '000') {
                        const token = datas
                        const expired = (Date.parse(new Date()) / 1000) + 7100 // 只需精确到秒
                        localStorage.setItem("account", account)
                        localStorage.setItem("token", token)
                        localStorage.setItem("expired", expired);
                        resolve(datas)
                        //return response.message.data
                    } else {
                        rejiect(datas)
                    }
                })
                .catch(err => rejiect('Request Failed', err));
        })
    } else {
        return token
    }
}

// export default fReq